import React from 'react';

import { isGoGameEnv } from 'App/constants';

import { Button, SidePage, Stack, Tabs, Tab, Box } from '@gogame/components';
import { useIsAllowed } from '@gogame/permissions';
import ApplyButton from 'scenes/Trackers/Tracker/components/ApplyButton';
import { PERMISSION_ID } from 'scenes/Trackers/Tracker/constants';
import { GeneralSection } from 'scenes/Trackers/components/Filters';
import CampaignsSection from './CampaignsSection';
import InfluencersChannelsSection from './InfluencersChannelsSection';
import AdvancedFilters, {
  AdvancedFiltersLabel,
} from 'scenes/Trackers/components/AdvancedFilters';
import { InfluencerChannelFilters } from './filters';

import {
  ClearFiltersButton,
  CompareFilters,
  EqualizeFilters,
  useFiltersStateManager,
  useFiltersFieldsManagerContext,
} from '@gogame/filters';

import {
  CreativeFilters,
  CreativeSection,
} from 'scenes/Trackers/CreativeFilters';
import GeneralTrackerFilters from './filters';

import {
  loadMetricsAdvancedList,
  loadMetricsAdvancedOperators,
} from 'scenes/Trackers/Tracker/sources/metrics';
import { useCurrentDimension } from '../../../hooks';

const FILTERS_TAB_ID = 0;
const ADVANCED_FILTERS_TAB_ID = 1;

const TrackerAllFilters = ({ open, onClose, onExited, params }) => {
  const {
    onLockPayTo,
    payToLocked,
    initialAdvancedFilters,
    hasUnappliedAdvancedFilters,
    onChangeAdvancedFilters,
    isCohortsMode,
  } = params;
  const isAllowed = useIsAllowed();

  const dimension = useCurrentDimension();
  const { collection } = useFiltersStateManager();
  const { compared } = useFiltersFieldsManagerContext();

  const [activeTabId, setActiveTabId] = React.useState(FILTERS_TAB_ID);
  const handleChangeTab = (_e, activeTabId) => {
    setActiveTabId(activeTabId);
  };

  const isFiltersTab = activeTabId === FILTERS_TAB_ID;
  const isAdvancedFiltersTab = activeTabId === ADVANCED_FILTERS_TAB_ID;

  return (
    <SidePage
      open={open}
      onClose={onClose}
      onExited={onExited}
      data-cy={'filtersSidepage'}
      width={916}
    >
      <SidePage.Title
        actions={
          isFiltersTab ? (
            <React.Fragment>
              {collection ? <CompareFilters /> : null}
              <EqualizeFilters disabled={!compared} />
            </React.Fragment>
          ) : null
        }
      >
        <Box pl={1.5}>
          <Tabs value={activeTabId} onChange={handleChangeTab}>
            <Tab label={'Filters'} sx={{ height: 60 }} value={FILTERS_TAB_ID} />
            <Tab
              label={
                <AdvancedFiltersLabel
                  title={'Advanced Filters'}
                  changed={hasUnappliedAdvancedFilters}
                  filled={initialAdvancedFilters?.length > 0}
                />
              }
              data-cy-label={'Advanced Filters'}
              sx={{ height: 60 }}
              value={ADVANCED_FILTERS_TAB_ID}
            />
          </Tabs>
        </Box>
      </SidePage.Title>

      <SidePage.NewBody>
        {isFiltersTab ? (
          <React.Fragment>
            <GeneralSection
              onLockPayTo={onLockPayTo}
              payToLocked={payToLocked}
              filters={GeneralTrackerFilters}
            />
            {isGoGameEnv ? (
              <InfluencersChannelsSection filters={InfluencerChannelFilters} />
            ) : null}

            {isGoGameEnv || isAllowed(PERMISSION_ID) ? (
              <CreativeSection filters={CreativeFilters} />
            ) : null}

            <CampaignsSection />
          </React.Fragment>
        ) : null}
        {isAdvancedFiltersTab ? (
          <React.Fragment>
            <AdvancedFilters
              disabled={isCohortsMode}
              onChange={onChangeAdvancedFilters}
              values={initialAdvancedFilters}
              loadMetricsOperators={loadMetricsAdvancedOperators}
              loadMetricsList={loadMetricsAdvancedList}
              dimension={dimension}
            />
          </React.Fragment>
        ) : null}
      </SidePage.NewBody>

      <SidePage.Actions>
        <Stack flex={1} justifyContent={'space-between'} direction={'row'}>
          <Button onClick={onClose}>Close</Button>
          <Stack spacing={2} direction={'row'}>
            {isFiltersTab ? <ClearFiltersButton /> : null}
            <ApplyButton onClick={onClose} />
          </Stack>
        </Stack>
      </SidePage.Actions>
    </SidePage>
  );
};
export default TrackerAllFilters;
